/** Die Daten des Bereichs, dessen Seite gerade offen ist - einmal geladen, von allen Kacheln gelesen. */
import { createContext, useContext } from 'react';

import type { BereichBoardDaten } from '@/modules/areas/board/useBereichBoard';

export const BereichDatenKontext = createContext<BereichBoardDaten | null>(null);

export function useBereichDaten(): BereichBoardDaten {
  const d = useContext(BereichDatenKontext);
  if (!d) throw new Error('Bereichs-Kachel ausserhalb einer Bereichsseite.');
  return d;
}
